import React, { useState, useEffect, useRef, useContext } from "react";
import { ThemeContext } from "../../ThemeContext";

import lightClasses from "./Homeheader.module.css";
import darkClasses from "./Darkhomeheader.module.css";

import logo from "../../Assets/dshbrdlogo.png";
import logodark from "../../Assets/dshbrdlogo.png";
import hamburgerIcon from "../../Assets/Hamburger.svg";
import { Link } from "react-router-dom";

const Homheader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [stickyClass, setStickyClass] = useState("");
  const lastScrollY = useRef(0);

  const { theme } = useContext(ThemeContext); // 👈 Get current theme
  const classes = theme === "dark" ? darkClasses : lightClasses; // 👈 Pick correct stylesheet

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY === 0) setStickyClass("");
      else if (currentScrollY > lastScrollY.current) setStickyClass("show");
      else setStickyClass("hide");
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto";
    };
  }, []);

  return (
    <div className={classes.headerbodi}>
      <header
        className={`${classes.header} ${
          stickyClass ? classes.stickyHeader + " " + classes[stickyClass] : ""
        }`}
      >
        <div className={classes.headerInner}>
          <div className={classes.left}>
            <img
              src={theme === "dark" ? logodark : logo}
              alt="Promix Logo"
              className={classes.logo}
            />
          </div>

          <nav
            className={`${classes.nav} ${menuOpen ? classes.mobileMenu : ""}`}
          >
            <Link to="#">
              <p>Product</p>
            </Link>
            <Link to="#">
              <p>Pricing</p>
            </Link>
            <Link to="#">
              <p>Resources</p>
            </Link>
            <Link to="#">
              <p>Enterprise</p>
            </Link>
            <Link to="#">
              <p>Contact</p>
            </Link>
          </nav>

          <div className={classes.right}>
            <Link to="/signin">
              <p className={classes.signIn}>Sign In</p>
            </Link>
            <Link to="/signup">
              <button className={classes.trialBtn}>Start Free Trial</button>
            </Link>
            <button
              className={classes.hamburger}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <img
                src={hamburgerIcon}
                alt="Menu"
                className={classes.hamburgerIcon}
              />
            </button>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Homheader;
